module.exports = __webpack_public_path__ + "img/Notisphere_Icon_Crescent_Mono_Dark.3bd95575.png";